export * from "./add-comment.component";
